import { IDocumentCardPreviewProps, ImageFit, mergeStyleSets } from "@fluentui/react";
import { HelperService } from "../services/helperService";
import { IAccreditorRule } from "../types/IAccreditor";
import { ICourseWorkFlat } from "../types/IAssignment";
import { IAuthenticationStatusContext } from "../types/IAuthenticationStatusContext";
import { ICourse, ISemester, Semester } from "../types/ICourse";
import { IContentData } from "../types/Shared";

export const UNKNOWN_IMAGE_BASE_64 = "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"

export const thisIsDevEnvironment = window.location.origin.startsWith("http://localhost") || (process.env.NODE_ENV === 'development');

export const styles = mergeStyleSets({

    commandBarRoot: [{
        borderTop: "1px solid #eee",
        /*marginTop: 20,*/
        paddingTop: 10,
        paddingLeft: 8
    }],
    commandBarButtonRoot: [{
    }],
    commandBarButtonRootChecked: [{
        color: "red !important"
    }]
});


export const isCourseGraduateLevel = (course: ICourse): boolean => {  
    if(course.SIS.indexOf(".") > -1) {
        const splitOnSis = course.SIS.split(".");
        const is600Level = splitOnSis.length === 4 && splitOnSis[2].startsWith("6");
        const lastSection = splitOnSis[splitOnSis.length - 1];
        const containsG = lastSection.indexOf("G") > -1;   

        return containsG || is600Level;
    }
    else {
        const pattern = /\d{3}G\d{3}/;
        const match = course.SIS.match(pattern);
        return match !== null;
    }
}

export const fileExtensionsForImages = [".jpeg", ".gif", ".jpg", ".png", ".apng", ".svg", ".bmp", ".bmp", ".ico"];

export const officeFileExtensions = ['.pptx', '.docx', '.docm', '.dotm', '.dotx', '.doc','.xlsx', '.xlsb', '.xls', '.xlsm', '.pptx', '.ppsx', '.ppt', '.pps', '.pptm', '.potm', '.ppam', '.potx', '.ppsm'];

export const movieFileExtensions = [".mp4", ".mov", ".avi"];

export const handledFileTypes = [...fileExtensionsForImages, ...officeFileExtensions, ...movieFileExtensions, ".pdf"];

export const base64ToArrayBuffer = (base64: string): ArrayBuffer => {
    var binary_string = window.atob(base64);
    var len = binary_string.length;
    var bytes = new Uint8Array(len);
    for (var i = 0; i < len; i++) {
        bytes[i] = binary_string.charCodeAt(i);
    }
    return bytes.buffer;
}

export type SemsterPrefix = "90" | "50" | "10" | "95"

export const getCanvasSemseterPrefix = (semester: string) => {
    let prefix: SemsterPrefix = "10";
    switch (semester) {
        case "Spring":
            prefix = "10";
            break;
        case "Fall":
            prefix = "90";
            break;
        case "Summer":
            prefix = "50";
            break;
        case "Winter":
            prefix = "95";
            break;
    }
    return prefix;
}

export const getCanvasSemseterPrefixFromCanvasCode = (canvasCode: string): Semester => {
    let semester: Semester = "Fall";
    switch (canvasCode) {
        case "10":
            semester = "Spring";
            break;
        case "90":
            semester = "Fall";
            break;
        case "50":
            semester = "Summer";
            break;
        case "95":
            semester = "Winter";
            break;
    }
    return semester;
}

export const getCurrentSemester = (courseName: string): ISemester | undefined => {
    let prefix = courseName?.split(".")[0] || "";
    if (prefix.length === 6) {
        const year = prefix.substring(0, 4);
        const semPrefix = prefix.substring(4);
        let semester: string = "";
        switch (semPrefix) {
            case "10":
                semester = "Spring";
                break;
            case "90":
                semester = "Fall";
                break;
            case "50":
                semester = "Summer";
                break;
            case "95":
                semester = "Winter";
                break;
        }
        const retVal: ISemester = {
            Semester: semester as Semester,
            Year: Number(year)
        };
        return retVal;
    }
    else {
        return undefined;
    }
};

export const getSemesterFromSisCode = (sisCode: string): ISemester | undefined => {
    let prefix = sisCode?.split(".")[0] || "";
    if (prefix.length === 6) {
        const year = prefix.substring(0, 4);
        const semPrefix = prefix.substring(4);
        let semester: string = "";
        switch (semPrefix) {
            case "10":
                semester = "Spring";
                break;
            case "90":
                semester = "Fall";
                break;
            case "50":
                semester = "Summer";
                break;
            case "95":
                semester = "Winter";
                break;
        }
        const retVal: ISemester = {
            Semester: semester as Semester,
            Year: Number(year)
        };
        return retVal;
    }
    else {
        return undefined;
    }
};

export const getMegabytesToBytes = (mb: number) => {
    return mb * 1048576;
}

export const onOpenFileInTab = (ev: React.MouseEvent<HTMLElement | HTMLAnchorElement | HTMLButtonElement, MouseEvent>, url: string, fileName: string) => {
    ev.preventDefault();
    const openedWindow = window.open();
    if(openedWindow)
    {
        openedWindow.location.assign(url);
        openedWindow.document.title = fileName;
        const title = openedWindow.document.createElement("title");
        title.innerText = fileName;
        openedWindow.document.head.appendChild(title);
        openedWindow.onload = () => {
            openedWindow.document.title = fileName;
        }                     
    }
}

export const sendApiRequest = (path: string, method: "GET" | "POST" | "PATCH" | "DELETE", body?: string | FormData, abortSignal?: AbortSignal, noHeaders?: boolean ): Promise<any> => {
    const apiPath = thisIsDevEnvironment ? `https://localhost:8080${path}` : path;
    let reqHeaders: HeadersInit | undefined = { "Content-Type": "application/json" };
    if(noHeaders)
    {
        reqHeaders = undefined;
    }   
    return new Promise(async (resolve, reject) => 
        fetch(apiPath, { "method": method, headers: reqHeaders, body: body, credentials: "include", signal: abortSignal }).then(async (r) => {
        if (!r.ok) {
            try {
                const text = await r.text();
                reject(text);
            }
            catch (err) {
                const json = await r.json();
                reject(json);
            }
        }
        else {
           if (r.statusText.toLowerCase() === "no content") {
                resolve({});
            }
            else {
                resolve(r.json());
            }
        }
    }).catch(err => {
        reject(err);
    }));
}

export const getServerHost = () => {
    return thisIsDevEnvironment ? 'localhost:8080' : window.location.hostname;
}

export const isCanvasTeacher = (authContext: IAuthenticationStatusContext) => {
    return authContext.CanvasAuthStatus?.roles?.includes("Teacher") || authContext.CanvasAuthStatus?.roles?.includes("Instructor");
}

export const isCanvasStudent = (authContext: IAuthenticationStatusContext) => {
    return authContext.CanvasAuthStatus?.roles?.includes("Learner");
}

export const isKeplerAccreditor = (authContext: IAuthenticationStatusContext) => {
    return authContext?.KeplerAuthStatus?.idTokenClaims?.roles?.includes("Accreditors");
}

export const isMyCourse = (authContext: IAuthenticationStatusContext, courses: ICourse[]) => {
    return courses.filter(c => authContext.Courses.map(c => c.CanvasId).includes(c.CanvasId)) || courses.filter(c => authContext.Courses.map(c => c.SIS).includes(c.SIS));
}

export const isCurrentUserAStudentOrTeacherInCourse = (authContext: IAuthenticationStatusContext, course: ICourse) => {
    return authContext.Courses.map(c => c.CanvasId?.toString()).includes(course.CanvasId?.toString()) || authContext.Courses.map(c => c.SIS?.toString()).includes(course.SIS?.toString());
}

export const getFileName = (authContext: IAuthenticationStatusContext | undefined, accreditorRules: IAccreditorRule[] | undefined, item: ICourseWorkFlat, index: number) => {
    return authContext && isKeplerAccreditor(authContext) && accreditorRules?.find(ar => ar.Accreditor.AccreditorName === authContext?.KeplerAuthStatus.idTokenClaims.companyName)?.Accreditor.ShouldAnonymizeStudents ? `Coursework ${index}${item.FileExtension}` : item.FileName;
}

export const getStudentName = (authContext: IAuthenticationStatusContext | undefined, accreditorRulesContext: IAccreditorRule[] | undefined, studentName: string, index: number | undefined) => {

    if (authContext && isKeplerAccreditor(authContext) && accreditorRulesContext?.find(ar => ar.Accreditor.AccreditorName === authContext?.KeplerAuthStatus.idTokenClaims.companyName)?.Accreditor.ShouldAnonymizeStudents) {
        if (index !== undefined) {
            return `Student ${index + 1}`;
        }
        else {
            return "Anonymous Student";
        }
    }
    else {
        return studentName;
    }
}

export const getPreviewProps = (fileName: string, fileBase64?: IContentData, imageHeight?: number, loading?: boolean): IDocumentCardPreviewProps => {
    return {
        previewImages: [
            {
                name: fileName,
                previewImageSrc: `data:${"image/png"};base64,${fileBase64?.base64 || UNKNOWN_IMAGE_BASE_64}`,
                iconSrc: "",
                imageFit: ImageFit.cover,
                height: loading ? (imageHeight || 180) - 2 : imageHeight || 180,
                
            },
        ]
    };
};

export const loadScript = (url: string) => {
    return new Promise<void>((resolve, reject) => {
        const existingScriptEl = document.querySelectorAll(`script[src='${url}']`);
        if(existingScriptEl.length > 0)
        {
            resolve();
        }
        else
        {
            var script = document.createElement("script") as any;
            script.type = "text/javascript";
            if (script.readyState) {  //IE
                script.onreadystatechange = function () {
                    if (script.readyState === "loaded" ||
                        script.readyState === "complete") {
                        script.onreadystatechange = null;
                        resolve();
                    }
                };
            } else {  //Others
                script.onload = function () {
                    resolve();
                };
            }
            script.onerror = function () {
                reject();
            };
            script.src = url;
            document.getElementsByTagName("head")[0].appendChild(script);
        }
    });
};

const _getSemesterToInt = (semester: Semester): number => {
    let retVal = 99;
    switch (semester) {
        case "Spring":
            retVal = 0;
            break;
        case "Summer":
            retVal = 1;
            break;
        case "Fall":
            retVal = 2;
            break;
        case "Winter":
            retVal = 3;
            break;
    }
    return retVal;
}

export const shouldGetCourseDataFromCanvasAPIs = async (semester: ISemester, authContext: IAuthenticationStatusContext) => {
    try {
        const yearForCutoverToCanvas = await HelperService.getKeplerEnvironmentVariable("REACT_APP_YEAR_FOR_CUTOVER_TO_CANVAS", true)
        const semesterToCutoverToCanvas = await HelperService.getKeplerEnvironmentVariable("REACT_APP_SEMESTER_FOR_CUTOVER_TO_CANVAS", true)      
        if (yearForCutoverToCanvas && semesterToCutoverToCanvas) {
            const retVal = !isKeplerAccreditor(authContext) && 
            (semester.Year > Number(yearForCutoverToCanvas) 
            || ((semester.Year === Number(yearForCutoverToCanvas) && 
            _getSemesterToInt(semester.Semester) >= _getSemesterToInt(semesterToCutoverToCanvas as Semester))));
            return retVal;
        }
        else {
            console.log("Invalid configuration");
            return false;
        }
    }
    catch (err) {
        console.log("Unable to aquire variable", err);
    }
}

const _saveFile = (url: string, filename: string) => {
    let retVal = false;
    const dataUri = url?.trim();
    const download = filename?.trim();
    try {
        var elem: HTMLAnchorElement = window.document.createElement("a");
        elem.classList.add("deals-download");
        window.document.body.append(elem);
        elem.href = url;
        elem.download = download;
        elem.setAttribute("style", "display: none !important;");
        elem.click();
    }
    catch (err) {
        console.error(`An error occurred saveing a file. Filename: ${download}; Url: ${dataUri}`, err);
    }
    return retVal;
}

export const saveBase64 = (data: string, filename: string) => {
    const content = data?.trim();
    if (content.length > 0) {
        _saveFile(`data:application/octet-stream;base64,${content}`, filename);
    }
    else {
        console.log(`saveBase64 called with no data. Filename: ${filename}`);
    }
}

export const b64toBlob = (b64Data: string, contentType = '', sliceSize = 512) => {
    const byteCharacters = atob(b64Data);
    const byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
        const slice = byteCharacters.slice(offset, offset + sliceSize);

        const byteNumbers = new Array(slice.length);
        for (let i = 0; i < slice.length; i++) {
            byteNumbers[i] = slice.charCodeAt(i);
        }

        const byteArray = new Uint8Array(byteNumbers);
        byteArrays.push(byteArray);
    }

    const blob = new Blob(byteArrays, { type: contentType });
    return blob;
}

export const getImageDimensions = (base64: string, imageType?: string): Promise<{ w: number, h: number }> => {
    return new Promise((resolve) => {
        var i = new Image()
        i.onload = function () {
            resolve({ w: i.width, h: i.height })
        };
        i.src = `data:${imageType ||  "image/png"};base64,${base64}`
    })
}

export const humanFileSize = (bytes: number, si = true, dp = 1) => {
    const thresh = si ? 1000 : 1024;

    if (Math.abs(bytes) < thresh) {
        return bytes + ' B';
    }

    const units = si
        ? ['kB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']
        : ['KiB', 'MiB', 'GiB', 'TiB', 'PiB', 'EiB', 'ZiB', 'YiB'];
    let u = -1;
    const r = 10 ** dp;

    do {
        bytes /= thresh;
        ++u;
    } while (Math.round(Math.abs(bytes) * r) / r >= thresh && u < units.length - 1);


    return bytes.toFixed(dp) + ' ' + units[u];
}